import React from 'react'
import { Box, Typography } from '@mui/material'

export default function Signature({ sx = {} }) {
  return (
    <Box sx={{ py: 1.5, textAlign: 'center', borderTop: '1px solid', borderColor: 'divider', ...sx }}>
      <Typography variant="caption" color="text.secondary">
        Cette plateforme a été fièrement construite par{' '}
        <a
          href="https://www.nouratech.sn"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontWeight: 'bold', textDecoration: 'none', color: 'inherit' }}
        >
          Noura Tech
        </a>
      </Typography>
    </Box>
  )
}
